import styled, { css } from 'styled-components'
import { MediaQueries } from 'utils/breakpoints'

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 80px);
  max-width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const ButtonsWrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 0 8px;

  ${MediaQueries.medium} {
    width: 60%;
    margin: 0 auto;
  }
`

export const Button = styled.button<{ buttonColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: transparent;

  width: 100%;
  padding: 12px 0;
  border: 1px solid;
  border-radius: 4px;

  font-weight: bold;

  /* btnColor params */
  ${({ buttonColor }) => {
    if (buttonColor) {
      return css`
        color: ${buttonColor};
        border-color: #${buttonColor};

        &:hover {
          background-color: ${buttonColor};
          color: white;
        }
      `
    }
  }}
`

export const ButtonImage = styled.img`
  margin-right: 8px;
  max-width: 100%;
  max-height: 100%;
`

export const UserButtonWrapper = styled.div`
  position: relative;
`

export const LogoutOptionWrapper = styled.div`
  position: absolute;
  top: 36px;
  right: -1px;
  z-index: 2;

  padding: 8px 24px;
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(206, 208, 221);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const LogoutOptionLabel = styled.p`
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: rgb(0, 0, 0);
  transition: font-weight 0.2s ease-in-out;

  &:hover {
    font-weight: 600;
  }
`
